module.exports = __webpack_public_path__ + "static/media/tractor (1).2f50c876.svg";